import React from "react";
import { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { API_URL } from "../../../../constants";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

const CandidateIntrList = () => {
  const [statusList, setStatusList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [apiStatus, SetApiStatus] = useState(undefined);

  useEffect(() => {
    fetchStatusList();
  }, [searchTerm]);

  const fetchStatusList = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}report/2`);
      SetApiStatus(response?.status);
      const apidata = response?.data?.data;
      setStatusList(apidata);
    } catch (error) {
      console.error("Error fetching status list:", error);
    }
  };
  
  const columns = {
    FullName:{text:"Name",visible:true},
    Round:{text:"Round",align:"center",visible:true},
    InterviewDate:{text:"Interview Date",align:"center",visible:true}
  };
  const defaultColumns = {
    FullName:true,
    Round: true,
    InterviewDate: true
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Candidate Interview List"))
  }, [])
  return (
    <>
        <div className="container-fluid" id="skill_section">
          <div className="container-fluid" id="skill-table-area">
              <Dynamic_PR_table
                data={statusList}
                columns={columns}
                defaultColumns={defaultColumns}
                itemsPerPage={8}
                isSorting={true}
                isApiStatus={apiStatus}
                isRequiredStatus={true}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>
          </div>
    </>
  );
};

export default CandidateIntrList;
